import { Stack } from '@chakra-ui/react';
import { useIsoStates } from '@pelicargo/ui';
import { COUNTRIES } from '@pelicargo/utils';
import { useFormContext } from 'react-hook-form';

import { SimpleInput } from '../SimpleInput';
import { SimpleReactSelect } from '../SimpleReactSelect';

type Props = {
  name: string;
  ignoreOnBlur?: boolean;
};

export const AddressForm = ({ name, ignoreOnBlur = false }: Props) => {
  const getFieldName = (fieldName: string) => `${name}.${fieldName}`;

  const { control } = useFormContext();

  const states = useIsoStates(control, getFieldName('country'));

  return (
    <Stack spacing={4}>
      <SimpleInput name={getFieldName('recipient')} label="Business name or recipient" ignoreOnBlur={ignoreOnBlur} />
      <SimpleInput name={getFieldName('line_one')} label="Line 1" ignoreOnBlur={ignoreOnBlur} />
      <SimpleInput name={getFieldName('line_two')} label="Line 2" ignoreOnBlur={ignoreOnBlur} />
      <Stack direction="row">
        <SimpleReactSelect
          name={getFieldName('country')}
          label="Country"
          options={COUNTRIES.map((country) => ({
            label: country?.name,
            value: country?.code,
          }))}
          ignoreOnBlur={ignoreOnBlur}
        />
        <SimpleReactSelect name={getFieldName('state')} label="State" options={states} ignoreOnBlur={ignoreOnBlur} />
      </Stack>
      <Stack direction="row">
        <SimpleInput name={getFieldName('city')} label="City" ignoreOnBlur={ignoreOnBlur} />
        <SimpleInput name={getFieldName('zip_code')} label="Zipcode" ignoreOnBlur={ignoreOnBlur} />
      </Stack>
    </Stack>
  );
};
